var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 py-1.5 -mx-2 rounded-sm min-w-[15rem] mb-2",class:{
    'bg-slate-100 dark:bg-slate-600 dark:text-slate-50':
      _vm.messageType === _vm.MESSAGE_TYPE.INCOMING,
    'bg-green-600 text-green-50': _vm.messageType === _vm.MESSAGE_TYPE.OUTGOING,
  }},[_c('message-preview',{attrs:{"message":_vm.message,"show-message-type":false,"default-empty-message":_vm.$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }